import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EMPTY, switchMap } from 'rxjs';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { DadoAdicionalItemService } from 'src/app/shared/services/dado-adicional-item.service';
import { OpcaoComboService } from 'src/app/shared/services/opcao-combo.service';
import { NavigationService } from '../../../services/navigation.service';

@Component({
  selector: 'app-dado-adicional-item-edit',
  templateUrl: './dado-adicional-item-edit.component.html',
  styleUrls: ['./dado-adicional-item-edit.component.scss']
})
export class DadoAdicionalItemEditComponent extends BaseFormComponent<any> implements OnInit {

  actionLabel: string = 'Novo';
  formErrors: boolean = false;
  tiposArray: any;
  casasDecimaisArray: any;
  ativoArray: any;
  model: {};

  form = this.fb.group({
    id: [''],
    title: ['', [Validators.required, Validators.maxLength(255)]],
    report_title: ['', Validators.maxLength(255)],
    ref_link: ['', Validators.maxLength(2083)],
    type_id: [1, Validators.required],
    max_length: ['', Validators.maxLength(255)],
    dec_places: [0],
    actived: [1, Validators.required],
    opcoesCombo: this.fb.array([]),
  });

  get title() { return this.form.get('title'); }
  get report_title() { return this.form.get('report_title'); }
  get ref_link() { return this.form.get('ref_link'); }
  get type_id() { return this.form.get('type_id'); }
  get max_length() { return this.form.get('max_length'); }
  get actived() { return this.form.get('actived'); }
  get dec_places() { return this.form.get('dec_places'); }
  get opcoesCombo() { return this.form.get('opcoesCombo') as FormArray; }

  constructor(
    private dadoAdicionalService: DadoAdicionalItemService,
    private opcaoCombo: OpcaoComboService,
    public activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private navigation: NavigationService
  ) {
    super(activatedRoute)
  }

  ngOnInit() {
    this.dadoAdicionalService.tipos().subscribe((res: any) => {
      this.tiposArray = Object.values(res);
    });
    this.dadoAdicionalService.casasDecimais().subscribe((res: any) => {
      this.casasDecimaisArray = Object.values(res);
    });
    this.dadoAdicionalService.ativoLista().subscribe((res: any) => {
      this.ativoArray = Object.values(res);
    });

    this.activatedRoute.params.subscribe((params) => {
      if (params.id && params.id != 'adicionar') {
        this.dadoAdicionalService.show(params.id).pipe(
          switchMap(res1 => {
            this.model = res1;
            this.form.patchValue(this.model);

            if (this.model['type_id'] == 5) { // Tipo Combo, busca as opções cadastradas para o combo
              return this.opcaoCombo.show(params.id);
            } else {
              return EMPTY;
            }
          })
        ).subscribe({
          next: (res2: []) => {
            this.opcoesCombo.clear();
            for (const dado of res2) {
              const opcaoFormGroup = this.fb.group({
                opcao_id: [dado['id']],
                question_id: [dado['question_id']],
                ds_value: [{ value: dado['ds_value'], disabled: dado['isUsed'] }, Validators.required]
              });
              this.opcoesCombo.push(opcaoFormGroup);
            }

            if (this.model['isUsed']) {
              this.title.disable();
              this.type_id.disable();
              this.dec_places.disable();
            }
          },
          error: (error) => {
            this.loaded();
            this.msgError(error.error);
            this.router.navigate(['projetos/admin-spgg/dados-adicionais-item']);
          },
          complete: () => {
            this.loaded();
          }
        });
        this.actionLabel = 'Editar';
      } else {
        this.loaded();
      }
    });
  }

  // Campo Opções no combo, quando o tipo Combo é selecionado
  addInput() {
    this.opcoesCombo.push(this.fb.group({
      'opcao_id': [''],
      'ds_value': ['', Validators.required],
      'question_id': [''],
    }));
  }
  removeInput(index: number) {
    this.opcoesCombo.removeAt(index);
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      this.model = this.form.value;
      if (this.model['id'] != null && this.model['id'] != '') {
        this.dadoAdicionalService.update(this.model).subscribe({
          next: (retorno) => {
            this.msgSuccess('Cadastro alterado com sucesso!');
            this.loaded();
          },
          error: (error) => {
            this.msgError(error.error);
            this.loaded();
          },
        });
      } else {
        this.dadoAdicionalService.store(this.model).subscribe({
          next: (retorno) => {
            this.msgSuccess('Cadastro criado com sucesso!');
            this.navigation.replace(['projetos/admin-spgg/dados-adicionais-item']);
            this.loaded();
          },
          error: (error) => {
            this.msgError(error.error);
            this.loaded();
          },
        });
      }
    }
    else {
      this.markAsDirty();
    }
  }

  voltar(): void {
    this.navigation.back(['projetos/admin-spgg/dados-adicionais-item']);
  }

}
